import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { connect } from 'react-redux'
import { renderRoutes } from 'react-router-config'

import { ParticipantSubHeader } from 'components/sections/assessor'
import { apiAssessors } from 'helpers/decorators/api'
import { ACTIVITY_SECTIONS } from 'constants/enums'
import config from 'config'

@apiAssessors()
@connect((state, props) => {
  // TODO: use reselect
  const { assessor, params } = props

  let activeJourney = null

  const activeAward = get(
    assessor,
    'participants.list',
    []
  ).find(participant => {
    activeJourney = get(participant, 'adventurousJourneys', []).find(
      journey => get(journey, 'id') === Number(params.ajId)
    )

    return activeJourney
  })

  return {
    activeJourney,
    activeAward,
    activeParticipant: get(activeAward, 'participant')
  }
})
class AJDetailAssessor extends Component {
  static propTypes = {
    route: PropTypes.object,
    activeJourney: PropTypes.object,
    activeAward: PropTypes.object,
    activeParticipant: PropTypes.object,
    params: PropTypes.object
  }

  render() {
    const {
      activeAward,
      activeJourney,
      activeParticipant,
      route,
      params
    } = this.props

    return (
      <div>
        <ParticipantSubHeader
          activityRoute={`${config.publicPath}/assessor/adventurous-journey/${params.ajId}`}
          activitySection={ACTIVITY_SECTIONS.adventurous_journey.id}
          avatar={get(activeParticipant, 'photoUrl')}
          completionText={get(activeJourney, 'ajEvent.ajEventCategory.translationText')}
          hideProgress
          isMajor={get(activeJourney, 'isMajor')}
          name={get(activeParticipant, 'name')}
          showReport
        />
        {route && renderRoutes(route.routes, {
          journey: activeJourney,
          award: activeAward,
          isAssessor: true,
          isAJ: true
        })}
      </div>
    )
  }
}

export default AJDetailAssessor
